// todo type에서 enum으로 바꾸는 작업 필요. (실수 방지용)

export type MemberRoleType = 'owner' | 'board' | 'member';

export type MemberStatusType = 'ok' | 'exit' | 'expel' | 'join' | 'reject' | 'cancel';

export type MemberBanType = 'suju_ban';

export type FeeType = 'percent' | 'amount';

export type LinkedBaechaStatusType = 'linked' | 'request' | 'received';

export type FeeFromType = 'group' | 'link';

export type MhType = '1h' | '2h' | '4h' | '1d' | 'm';

export enum PriceReceiveMethodEnum {
	DIRECT_AD = 'direct_ad', // 직수
	DIRECT_NOAD = 'direct_noad', // 현수
	SIGN = 'sign', // 싸인
};

export type PriceType = 'new' | 'mid' | 'old' | 'none';

export type BaljuSujuType = 'balju' | 'suju';

export type CashTxStatusType = 'done' | 'cancel' | 'hold';

export type CashTxRequestType = 'fee' | 'service' | 'deposit' | 'withdrawal';

export type CarType = 'all' | '1t' | '2t' | '3t' | '1-2t' | '2-3t' | '1-3t' | '5t' | '54m' | '58m' | '75m' | '5t_over' | '54m_over' | '58m_over'
	| '28m' | '40m' | '60m' | '70m';

export type WheelbaseType = 'long' | 'mid' | 'short';

export type BaechaType = 'rollcall' | 'normal' | 'urgent' | 'designated';

export type CallPassType = 'call' | 'pass';

export type PointPeriodType = 'half_month' | 'month' | 'last30' | 'last60' | 'last90' | 'all_time';

export type RankingPeriodType = 'pre_half_month' | 'this_half_month' | 'next_half_month' | 'pre_month' | 'this_month' | 'next_month' | 'last30' | 'last60' | 'last90' | 'all_time';

export type ScheduleType = 'ready' | 'am' | 'pm' | 'am_ready' | 'pm_ready' | 'day' | 'absence' | 'dayoff'; //'am_part' | 'pm_part' 사용안함

export type BaljuStatusType = 'balju' | 'suju' | 'designated_reject' | 'suju_zero' | 'balju_cancel' | 'complete' | 'delete' | 'save';

export type GroupStatus = 'active' | 'delete';

export type BaechaWorkDayType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
	| 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20
	| 21 | 22 | 23 | 24 | 25 | 26 | 27 | 28 | 29 | 30
	| 31;

export type FCMMessageType = 'topic' | 'user' | 'member';

export type VerifyStatusType = 'review' | 'verified' | 'rejected';

export type PolicyType = 'l' | 'p' | 's'; // l: location, p: privacy, s: service

export type UserStatusType = 'active' | 'delete';

export type ChatMessageMsgType = 'text' | 'image' | 'audio' | 'video' | 'file' | 'custom';

export type ChatMessageCustomType = 'private_info' | 'baecha_work_day'; // ChatMessageType이 custom일 때만 지정

export type ChatMessageContextType = 'baecha' | 'baechaWorkDay' | 'group';

export enum BucketFileLinkObjectNameEnum {
	BAECHA = 'baecha',
	BAECHA_WORK_DAY = 'baecha_work_day',
	GROUP = 'group',
};

export type ChatMessageStatusType = 'active' | 'modified' | 'deleted';

export type SignedURLActionType = 'write' | 'read';

export type SubscriptionActionType = 'CLIENT_PURCHASE' | 'CLIENT_RESTORE';

export type SubscriptionProviderIdType = 'google' | 'apple' | 'platmatch';

export type SubscriptionProductIdType =
	'test_baechajang_gf_sub_month'
	| 'test_baechajang_gf_sub_year'
	| 'test_baechajang_af_sub_month'
	| 'test_baechajang_af_sub_year'
	| 'baechajang_gf_sub_month'
	| 'baechajang_gf_sub_year'
	| 'baechajang_af_sub_month'
	| 'baechajang_af_sub_year'
	| 'baechajang_platmatch_lifetime';


/**
 * ### 구독 상태별 서비스 이용 및 갱신 현황
 * | 상태 (Status) | 서비스 사용 | 자동 갱신 | 주요 특징 및 발생 시나리오 |
 * | :--- | :---: | :---: | :--- |
 * | ACTIVE | O | O | 정상 결제 완료 및 유지 상태. 가장 일반적인 활성 상태. |
 * | IN_GRACE | O | 대기 | 결제 수단 문제로 갱신 실패했으나, 유예 기간(7~14일) 동안 혜택 유지. |
 * | CANCELED | O | X | 사용자가 '구독 해지'를 예약함. 만료일(expireDate)까지는 사용 가능. |
 * | PENDING | X | 대기 | 결제 승인 대기 중(편의점 결제 등). 최종 승인 전까지 혜택 미지급. |
 * | PAUSED | X | X | 사용자가 일정 기간 구독을 멈춤(Google 전용). 재개 전까지 혜택 중단. |
 * | ON_HOLD | X | 대기 | 유예 기간 종료 후에도 결제 실패. 결제 수단 수정 전까지 서비스 차단. |
 * | EXPIRED | X | X | 구독 기간 만료. 재결제 전까지 서비스 이용 불가. |
 * | REVOKED | X | X | 스토어 측의 강제 권한 회수(가족 공유 이탈, 부정 결제 등). 즉시 차단. |
 * | REFUNDED | X | X | 결제 취소 및 환불 처리됨. 즉시 서비스 권한 회수. |
 */
// 서비스 사용 가능한 경우: ACTIVE, CANCELED, IN_GRACE
export type SubscriptionStatusType =
	| 'ACTIVE'
	| 'EXPIRED'
	| 'CANCELED'
	| 'REVOKED'
	| 'IN_GRACE'
	| 'PAUSED'
	| 'ON_HOLD'
	| 'PENDING'
	| 'REFUNDED';

export enum PointAdjustHistoryCodeEnum {
	MEMBERSHIP = 'membership',
	MEMBERSHIP_REFUND = 'membership_refund',
	LOW_LIMIT_POINT_ADJUST = 'low_limit_point_adjust',
}

export enum BaechaWorkDayStatusEnum {
	SAVE = 'save', // 임시저장
	REQUEST = 'request', // 요청
	CANCEL = 'cancel', // 요청 취소
	APPROVE = 'approve', // 승인
	REJECT = 'reject', // 거절
}

export enum UserMannerTypeEnum {
	GREAT = 'great',
	GOOD = 'good',
	BAD = 'bad',
}

export enum UserMannerCodeEnum {
	// GREAT
	GREAT_FRIENDLY = 'great_friendly',
	GREAT_RESPONSIVE = 'great_responsive',
	GREAT_SKILLED = 'great_skilled',
	GREAT_GOOD_PRICE = 'great_good_price',
	GREAT_FAST_PAYMENT = 'great_fast_payment',
	GREAT_CUSTOM = 'great_custom',

	// GOOD
	GOOD_FRIENDLY = 'good_friendly',
	GOOD_RESPONSIVE = 'good_responsive',
	GOOD_SKILLED = 'good_skilled',
	GOOD_GOOD_PRICE = 'good_good_price',
	GOOD_FAST_PAYMENT = 'good_fast_payment',
	GOOD_CUSTOM = 'good_custom',

	// BAD
	BAD_UNFRIENDLY = 'bad_unfriendly',
	BAD_LATE_PAYMENT = 'bad_late_payment',
	BAD_EXCESSIVE_DEMAND = 'bad_excessive_demand',
	BAD_NO_RESPONSE = 'bad_no_response',
	BAD_UNSKILLED = 'bad_unskilled',
	BAD_ARGUMENT = 'bad_argument',
	BAD_LATE = 'bad_late',
	BAD_NO_SHOW = 'bad_no_show',
	BAD_NOTES_IGNORED = 'bad_notes_ignored',
	BAD_DOCUMENT_CANCELED = 'bad_document_canceled',
	BAD_CUSTOM = 'bad_custom',
}

export const USER_MANNER_DETAILS: Record<
	UserMannerCodeEnum,
	{ type: UserMannerTypeEnum; message: string }
> = {
	// GREAT
	[UserMannerCodeEnum.GREAT_FRIENDLY]: { type: UserMannerTypeEnum.GREAT, message: '매너 있고 친절해요.' },
	[UserMannerCodeEnum.GREAT_RESPONSIVE]: { type: UserMannerTypeEnum.GREAT, message: '사진, 전화 응답이 좋아요.' },
	[UserMannerCodeEnum.GREAT_SKILLED]: { type: UserMannerTypeEnum.GREAT, message: '실력 있고 서비스가 좋아요.' },
	[UserMannerCodeEnum.GREAT_GOOD_PRICE]: { type: UserMannerTypeEnum.GREAT, message: '단가가 좋아요.' },
	[UserMannerCodeEnum.GREAT_FAST_PAYMENT]: { type: UserMannerTypeEnum.GREAT, message: '결제가 빨라요.' },
	[UserMannerCodeEnum.GREAT_CUSTOM]: { type: UserMannerTypeEnum.GREAT, message: '' },

	// GOOD
	[UserMannerCodeEnum.GOOD_FRIENDLY]: { type: UserMannerTypeEnum.GOOD, message: '매너 있고 친절해요.' },
	[UserMannerCodeEnum.GOOD_RESPONSIVE]: { type: UserMannerTypeEnum.GOOD, message: '사진, 전화 응답이 좋아요.' },
	[UserMannerCodeEnum.GOOD_SKILLED]: { type: UserMannerTypeEnum.GOOD, message: '실력 있고 서비스가 좋아요.' },
	[UserMannerCodeEnum.GOOD_GOOD_PRICE]: { type: UserMannerTypeEnum.GOOD, message: '단가가 좋아요.' },
	[UserMannerCodeEnum.GOOD_FAST_PAYMENT]: { type: UserMannerTypeEnum.GOOD, message: '결제가 빨라요.' },
	[UserMannerCodeEnum.GOOD_CUSTOM]: { type: UserMannerTypeEnum.GOOD, message: '' },

	// BAD
	[UserMannerCodeEnum.BAD_UNFRIENDLY]: { type: UserMannerTypeEnum.BAD, message: '불친절해요.' },
	[UserMannerCodeEnum.BAD_LATE_PAYMENT]: { type: UserMannerTypeEnum.BAD, message: '결제가 느려요.' },
	[UserMannerCodeEnum.BAD_EXCESSIVE_DEMAND]: { type: UserMannerTypeEnum.BAD, message: '과도한 요구를 해요.' },
	[UserMannerCodeEnum.BAD_NO_RESPONSE]: { type: UserMannerTypeEnum.BAD, message: '사진, 전화 응답이 없어요.' },
	[UserMannerCodeEnum.BAD_UNSKILLED]: { type: UserMannerTypeEnum.BAD, message: '실력이 부족해요.' },
	[UserMannerCodeEnum.BAD_ARGUMENT]: { type: UserMannerTypeEnum.BAD, message: '현장에서 다투었어요.' },
	[UserMannerCodeEnum.BAD_LATE]: { type: UserMannerTypeEnum.BAD, message: '지각을 했어요.' },
	[UserMannerCodeEnum.BAD_NO_SHOW]: { type: UserMannerTypeEnum.BAD, message: '펑크를 냈어요.' },
	[UserMannerCodeEnum.BAD_NOTES_IGNORED]: { type: UserMannerTypeEnum.BAD, message: '특이사항을 확인하지 않았어요.' },
	[UserMannerCodeEnum.BAD_DOCUMENT_CANCELED]: { type: UserMannerTypeEnum.BAD, message: '서류건을 취소했어요.' },
	[UserMannerCodeEnum.BAD_CUSTOM]: { type: UserMannerTypeEnum.BAD, message: '' },
};
